import React from "react";
import ReactDOM from "react-dom";
import style from "./LoadingOverlay.module.css";

const LoadingOverlay = ({ isVisible, children, message  }) => {
  if (!isVisible) return null;

  return ReactDOM.createPortal(
    <div className={style.overlay}>
      <div className={style.messageBox}>
        {children}
        <p>{message}</p>
      </div>
    </div>,
    document.getElementById("protal")
  );
};
export default LoadingOverlay;